var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('HelloWorld',{attrs:{"msg":"杭州点顺科技有限公司"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }